import { useEffect, useRef } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useTemplatesModals } from "../../contexts/templatesModalsContext";
import { useDefaultAppRoute } from "../../hooks/useIsAdvertisersDemo";

const TemplatesLegacyRedirect = ({ kind }) => {
  const [searchParams] = useSearchParams();
  const { openTemplatesList, openTemplateEditor, openTemplateProduce } =
    useTemplatesModals();
  const didOpenRef = useRef(false);
  const defaultAppRoute = useDefaultAppRoute();

  useEffect(() => {
    if (didOpenRef.current) return;
    didOpenRef.current = true;
    if (kind === "list") {
      openTemplatesList();
      return;
    }
    if (kind === "editor") {
      const templateID = searchParams.get("templateID") || "";
      if (templateID) {
        openTemplateEditor({ templateID });
        return;
      }
      openTemplatesList();
      return;
    }
    if (kind === "produce") {
      openTemplateProduce({
        templateID: searchParams.get("templateID") || "",
        produceID: searchParams.get("produceID") || "",
      });
      return;
    }
    const exhaustiveCheck = kind;
    throw new Error(`Unhandled templates redirect kind: ${exhaustiveCheck}`);
  }, [
    kind,
    openTemplateEditor,
    openTemplateProduce,
    openTemplatesList,
    searchParams,
  ]);

  return <Navigate to={defaultAppRoute} replace />;
};

export default TemplatesLegacyRedirect;
